import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GridProps {}

export default function Grid(props: GridProps) {
  return <></>;
}

Grid.Row = Grid;
Grid.Col = Grid; // TODO: Remove placeholders
